import React from 'react';
import { Row, Col } from 'antd/lib/grid';

import { Button } from '@perxis/perxis-auto-ui-kit/lib/components/Button';
import { Icon } from '@perxis/perxis-auto-ui-kit/lib/components/Icon';
import { Typography } from '@perxis/perxis-auto-ui-kit/lib/components/Typography';

import style from './style.module.scss';

type Props = {
  className?: string;
};

const ThankStep = ({ className }: Props) => {
  return (
    <Row className={cn(style.row, className)} gutter={[0, 4]}>
      <Col span={24}>
        <Typography.Title level={2}>спасибо!</Typography.Title>
      </Col>
      <Col span={24}>
        <Typography.Paragraph>
          Благодарим за обращение. Ваша заявка успешно отправлена.
        </Typography.Paragraph>
      </Col>
      <Col span={24}>
        <Button
          type="ghost"
          href={window.location.origin}
          icon={<Icon name="arrow-1" width={16} height={16} />}
        >
          на главную
        </Button>
      </Col>
    </Row>
  );
};

export default ThankStep;
